import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BsGrid, BsPerson, BsJournalBookmark, BsNewspaper, BsBook, BsBoxArrowRight } from 'react-icons/bs';

const navItems = [
  { to: '/admin/groups', icon: <BsGrid />, label: 'Группы' },
  { to: '/admin/users', icon: <BsPerson />, label: 'Ученики' },
  { to: '/admin/rasp', icon: <BsJournalBookmark />, label: 'Расписание' },
  /* { to: '/admin/subjects', icon: <BsBook />, label: 'Предметы' }, */
  { to: '/admin/news', icon: <BsNewspaper />, label: 'Новости' },
];

export default function AdminBottomNavBar() {
  const navigate = useNavigate();
  const location = useLocation();

  if (window.innerWidth > 600) return null;

  return (
    <nav style={{
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      height: 60,
      background: '#fff',
      borderTop: '1px solid #ece9f7',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 100,
      boxShadow: '0 -2px 8px #ece9f7',
    }}>
      {navItems.map(item => (
        <button
          key={item.to}
          onClick={() => navigate(item.to)}
          style={{
            background: 'none',
            border: 'none',
            color: location.pathname.startsWith(item.to) ? '#6c3be4' : '#4c20bb',
            fontSize: 26,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            fontWeight: location.pathname.startsWith(item.to) ? 700 : 500,
          }}
        >
          {item.icon}
          <span style={{ fontSize: 12, marginTop: 2 }}>{item.label}</span>
        </button>
      ))}
      <button
        onClick={() => { localStorage.clear(); window.location.href = '/admin/login'; }}
        style={{
          background: 'none',
          border: 'none',
          color: '#e74c3c',
          fontSize: 26,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'pointer',
          fontWeight: 700,
        }}
      >
        <BsBoxArrowRight />
        <span style={{ fontSize: 12, marginTop: 2 }}>Выйти</span>
      </button>
    </nav>
  );
} 